import { render, staticRenderFns } from "./TableCellTypeImage.vue?vue&type=template&id=4074d5ee&scoped=true"
import script from "./TableCellTypeImage.vue?vue&type=script&lang=js"
export * from "./TableCellTypeImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4074d5ee",
  null
  
)

export default component.exports